module.exports = __webpack_public_path__ + "img/2.24b53b1b.png";